import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArrowDropUpIcon(props: FixMe) {
  return <ArrowDropUp {...props} />;
}

export default ArrowDropUpIcon;
